'use strict';

var scrapeMotionValues = require('../../html/utils/scrape-motion-values.cjs');
var isMotionValue = require('../../../../../../../../motion-dom/dist/es/value/utils/is-motion-value.cjs');
var keysTransform = require('../../../../../../../../motion-dom/dist/es/render/utils/keys-transform.cjs');

function scrapeMotionValuesFromProps(props, prevProps, visualElement) {
    const newValues = scrapeMotionValues.scrapeMotionValuesFromProps(props, prevProps, visualElement);
    for (const key in props) {
        if (isMotionValue.isMotionValue(props[key]) ||
            isMotionValue.isMotionValue(prevProps[key])) {
            const targetKey = keysTransform.transformPropOrder.indexOf(key) !== -1
                ? "attr" + key.charAt(0).toUpperCase() + key.substring(1)
                : key;
            newValues[targetKey] = props[key];
        }
    }
    return newValues;
}

exports.scrapeMotionValuesFromProps = scrapeMotionValuesFromProps;
//# sourceMappingURL=scrape-motion-values.cjs.map
